document.addEventListener("alpine:init", () => {
  Alpine.store("collection", {
    grid: 'small',
    isFacetsOpen: false,
    setGrid(grid) {
      this.grid = grid;
      window.dispatchEvent(new CustomEvent('collection:grid-changed'));
    }
  });
  
  Alpine.store('modals', {
    openModalId: null
  });
});
